import { ShareIcon } from "@heroicons/react/20/solid"
import { toast } from "react-toastify"

export const ShareButton = () => {
  const url = "https://401calc.showcase.coherent.global/"

  const share = () => {
    // logEvent("DemoAppShare")
    if (navigator && navigator.canShare && navigator.canShare({ url })) {
      navigator.share({ url })
    } else {
      navigator.clipboard.writeText(url).then(
        () => {
          toast("URL copied to clipboard.", {
            type: "success",
            position: "bottom-center",
            autoClose: 2000,
            progressClassName: "!bg-brand-light",
          })
        },
        () => {
          console.error("Clipboard write failed.")
        }
      )
    }
  }

  return (
    <button
      onClick={() => share()}
      className="bg-brand-light text-white w-8 h-8 flex items-center justify-center rounded"
      type="button"
    >
      <ShareIcon className="h-5 w-5" />
    </button>
  )
}

